import SquareSelectedSvg from "@assets/svg/SquareRadioSelect";
import SquareUnSelectedSvg from "@assets/svg/SquareRadioUnselect";
import Text from "@components/AppText";
import colors from "@constants/color";
import _ from "lodash";
import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import AddComment from "./AddComment";
import AddQuantity from "./AddQuantity";
import ImagesUpload from "./ImagesUpload";

const SelectReasonCommentImgs = (props) => {
  const {
    reasons = [],
    toBeRaised = {},
    selectedReturnType = "",
    setReason = () => {},
    setImages = () => {},
    setComment = () => {},
    setQuantity = () => {},
    rvpData,
  } = props;
  const selectedReasons = Object.keys(toBeRaised[selectedReturnType]);

  const Icon = ({ reason }) => {
    return selectedReasons.includes(reason?.key) ? (
      <SquareSelectedSvg />
    ) : (
      <SquareUnSelectedSvg />
    );
  };

  const onReasonSelect = (reason) => {
    reason.key && setReason(reason.key);
  };

  const Reason = ({ reason, i }) => {
    const currentComment = _.get(toBeRaised, [
      selectedReturnType,
      reason?.key,
      "user_comment",
    ]);
    const currentImgs = _.get(toBeRaised, [
      selectedReturnType,
      reason?.key,
      "image_upload",
    ]);
    const currentQty = _.get(toBeRaised, [
      selectedReturnType,
      reason?.key,
      "quantity",
    ]);

    const shouldShowCommentImageSection =
      (selectedReasons.includes(reason?.key) &&
        _.get(toBeRaised, [selectedReturnType, reason?.key, "quantity"]) > 0) ||
      false;

    return (
      <View
        key={i}
        style={[
          shouldShowCommentImageSection ? styles.border : {},
          { backgroundColor: "#fff" },
        ]}
      >
        <View
          style={[
            styles.rowContainer,
            shouldShowCommentImageSection ? {} : styles.border,
          ]}
        >
          <TouchableOpacity
            testID="rr-select-reason"
            key={reason?.key}
            onPress={() => onReasonSelect(reason)}
          >
            <View style={styles.iconAndReason}>
              <View style={styles.buttonContainer}>
                <Icon reason={reason} />
                <View>
                  <Text
                    fontType="content2"
                    style={styles.buttonOption}
                    numberOfLines={1}
                  >
                    {reason?.text || reason?.label || reason?.value}
                  </Text>
                </View>
              </View>
            </View>
          </TouchableOpacity>
          {selectedReasons.includes(reason?.key) ? (
            <View style={{ alignItems: "flex-end" }}>
              <AddQuantity
                key={reason?.key}
                reason={reason}
                currentQty={currentQty}
                setQuantity={setQuantity}
              />
            </View>
          ) : (
            <></>
          )}
        </View>
        {shouldShowCommentImageSection ? (
          <View style={{ paddingHorizontal: 18 }}>
            <AddComment
              key={`${reason.key}_AddComment`}
              rvpData={rvpData}
              reason={reason}
              currentComment={currentComment}
              setComment={setComment}
            />
            <ImagesUpload
              key={`${reason.key}_ImagesUpload`}
              rvpData={rvpData}
              reason={reason}
              imageRequired={reason?.images_mandatory}
              currentImgs={currentImgs}
              setUploadedImage={setImages}
            />
          </View>
        ) : (
          <></>
        )}
      </View>
    );
  };

  return (
    <View style={{ paddingVertical: 5 }}>
      {Array.isArray(reasons) && reasons.length
        ? reasons?.map((reason, i) => <Reason key={i} reason={reason} i={i} />)
        : null}
    </View>
  );
};

export default SelectReasonCommentImgs;

const styles = StyleSheet.create({
  rowContainer: {
    flexDirection: "row",
    paddingVertical: 8,
    paddingHorizontal: 18,
    minHeight: 50,
    alignItems: "center",
    justifyContent: "space-between",
  },
  border: {
    borderBottomWidth: 1,
    borderBottomColor: "rgba(0,0,0,0.1)",
  },
  iconAndReason: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttonContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  buttonOption: {
    marginLeft: 10,
    color: colors.mediumBlacklightBlack,
    width: 200,
  },
});
